import React from 'react';
import { Link } from 'react-router-dom';
import SpeakerIncentives from './SpeakerIncentives';
import SponsorIncentives from './SponsorIncentives';
import { ArrowRightIcon, UserGroupIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';
import { useConferenceSettings } from '../contexts/ConferenceSettingsContext';



const HomeIncentives: React.FC = () => {
  const { settings } = useConferenceSettings();

  // If neither CFP nor sponsorships are accepting, don't show this section
  if (!settings?.accepting_cfp && !settings?.accepting_sponsors) {
    return null;
  }

  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Join Europe's Premier Language Intelligence Conference
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            Whether you are a potential speaker or sponsor, be part of shaping the future of language intelligence
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="space-y-16">
            {/* Speaker Card */}
            {settings?.accepting_cfp && (
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                <div className="bg-[#00529B]/10 px-6 py-4 flex items-center border-b border-gray-100">
                  <UserGroupIcon className="w-8 h-8 text-[#00529B] mr-3" />
                  <h3 className="text-2xl font-bold text-[#00529B]">For Speakers</h3>
                </div>
                
                <div className="p-6">
                  <SpeakerIncentives />
                  
                  <div className="mt-6 text-center text-sm text-gray-600 font-medium">
                    <p>Call for speakers open until <span className="font-bold text-[#00529B]">15 July 2025</span></p>
                  </div>
                  
                  <div className="mt-6 text-center">
                    <Link
                      to="/cfp"
                      className="inline-flex items-center px-6 py-3 text-base font-medium rounded-md text-white bg-[#00529B] hover:bg-[#003D74] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00529B]"
                    >
                      Submit Your Proposal
                      <ArrowRightIcon className="ml-2 -mr-1 h-5 w-5" />
                    </Link>
                  </div>
                </div>
              </div>
            )}
            
            {/* Sponsors Card */}
            {settings?.accepting_sponsors && (
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                <div className="bg-[#00529B]/10 px-6 py-4 flex items-center border-b border-gray-100">
                  <BuildingOfficeIcon className="w-8 h-8 text-[#00529B] mr-3" />
                  <h3 className="text-2xl font-bold text-[#00529B]">For Sponsors</h3>
                </div>
                
                <div className="p-6">
                  <SponsorIncentives />
                  
                  <div className="mt-6 text-center text-sm text-gray-600 font-medium">
                    <p>Call for sponsors open until <span className="font-bold text-[#00529B]">31 August 2025</span></p>
                  </div>
                  
                  <div className="mt-6 text-center">
                    <Link
                      to="/sponsorship"
                      className="inline-flex items-center px-6 py-3 text-base font-medium rounded-md text-white bg-[#00529B] hover:bg-[#003D74] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00529B]"
                    >
                      Become a Sponsor
                      <ArrowRightIcon className="ml-2 -mr-1 h-5 w-5" />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeIncentives;
